import { Elevation } from "@blueprintjs/core";

import { LazyImg } from "@/components/helpers/ui/LazyImg";
import { Box, Flex } from "@/components/layout/flexbox";
import { Media } from "@/components/layout/Media";
import { OptionCard } from "@/components/pieces/onboarding/OptionCard";
import { SUBTEXT_COLOR } from "@/css/constants";
import { BasicSpecialty } from "@/types/products";

interface SpecialtyNeededOptionProps {
  specialty: BasicSpecialty;
  onClick: () => void;
  elevation?: Elevation;
  className?: string;
}

export function SpecialtyNeededOption({
  specialty,
  onClick,
  elevation,
  className,
}: SpecialtyNeededOptionProps) {
  const { iconUrl, shortDescription } = specialty;
  return (
    <OptionCard
      interactive={true}
      onClick={onClick}
      elevation={elevation || 2}
      p={0}
      className={className}
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
        pl={3}
        pr={3}
        height={90}
      >
        <Flex
          pr={24}
          alignItems="center"
          style={{
            transition: "color 200ms ease",
          }}
        >
          <Media greaterThan="xs">
            {iconUrl ? (
              <Box mr={3}>
                <LazyImg width={60} src={iconUrl} />
              </Box>
            ) : null}
          </Media>
          <div>
            <div>
              <b>{specialty.name}</b>
            </div>
            {shortDescription ? (
              <Box color={SUBTEXT_COLOR} mt={1}>
                {shortDescription}
              </Box>
            ) : null}
          </div>
        </Flex>
      </Flex>
    </OptionCard>
  );
}
